import { MinzeAttrs, MinzeElement } from "minze";

export class TjText extends MinzeElement {
  attrs: MinzeAttrs = [
    ["color", "#068FC3"],
    ["font-size", "16px"],
    ["font-weight", "400"],
    ["text-align"],
    "white-space",
    "text-decoration",
    "line-height",
  ];

  html = () => `
    <div class="text">
      <slot></slot>
    </div>
  `;

  css = () => `
    .text {
      color: ${this.color};
      font-size: ${this.fontSize};
      text-align: ${this.textAlign};
      font-weight: ${this.fontWeight};
      ${this.whiteSpace ? `white-space: ${this.whiteSpace};` : ""};
      ${this.textDecoration ? `text-decoration: ${this.textDecoration};` : ""};
      ${this.lineHeight ? `line-height: ${this.lineHeight};` : ""};
    }
  `;
}
